<template>
  <div class="body">
    <modal-wrapper v-show="isStockModalVisible" @hideModal="hideStockModal">
      <modal-content :stock="stockForModal" />
    </modal-wrapper>
    <div class="body__controls controls">
      <fhs-select
        class="controls__item"
        :options="securitiesTypes"
        @handleSelect="onSecurityTypeSelect"
      />
      <form @submit.prevent="handleSearchSubmit">
        <input
          v-model="searchQuery"
          type="search"
          class="controls__item controls__search"
          :placeholder="$t('search')"
        />
      </form>
    </div>
    <div class="body__table-container">
      <div v-show="isStockListLoading" class="body__table-preloader">
        <spinner :animation-duration="1000" :size="60" :color="'#2E79EF'" />
      </div>
      <table class="body__table table">
        <thead>
          <tr>
            <td class="table__head align-left">{{ $t("tool") }}</td>
            <td class="table__head align-right">Бид</td>
            <td class="table__head align-right">Спред</td>
            <td class="table__head align-right">Аск</td>
            <td class="table__head align-left">{{ $t("currency") }}</td>
            <td class="table__head align-left">{{ $t("status") }}</td>
            <td class="table__head table__head_long align-right">
              {{ $t("market price") }}
            </td>
            <td class="table__head align-center">{{ $t("favorites") }}</td>
            <!--            <td class="table__head align-right"></td>-->
          </tr>
        </thead>
        <tbody>
          <tr v-for="stockItem in stockList" :key="stockItem.isin">
            <td class="table__body align-left">
              <p>{{ stockItem.issuer }}</p>
              <p class="table__body_muted">{{ stockItem.isin }}</p>
            </td>
            <td class="table__body align-right">
              {{ formatMoney(stockItem.bid) }}
            </td>
            <td
              class="table__body align-right"
              :class="getIncomeColor(getIncome(stockItem.bid, stockItem.ask))"
            >
              {{ formatMoney(getIncome(stockItem.bid, stockItem.ask)) }}
            </td>
            <td class="table__body align-right">
              {{ formatMoney(stockItem.ask) }}
            </td>
            <td class="table__body align-left">{{ stockItem.currency }}</td>
            <td class="table__body align-left">N/A</td>
            <td class="table__body align-right">
              {{ formatMoney(stockItem.price) }}
              {{ stockItem.price ? stockItem.currency : null }}
            </td>
            <td class="table__body align-center">
              <!-- Выводим разные кнопки в зависимости от того, подписался пользователь на эту бумагу или нет -->
              <a
                v-if="isSubscribed(stockItem.isin) === 'true'"
                @click="handleFavoritesButtonClick"
                :id="stockItem.isin"
                :data-issubscribed="isSubscribed(stockItem.isin)"
                class="table__subscription-button"
                ><img
                  src="@/assets/images/selected_star.svg"
                  alt="Selected Star"
                  :id="stockItem.isin"
                  :data-issubscribed="isSubscribed(stockItem.isin)"
              /></a>
              <a
                v-else
                @click="handleFavoritesButtonClick"
                :id="stockItem.isin"
                :data-issubscribed="isSubscribed(stockItem.isin)"
                class="table__subscription-button"
                ><img
                  src="@/assets/images/muted_star.svg"
                  alt="Selected Star"
                  :id="stockItem.isin"
                  :data-issubscribed="isSubscribed(stockItem.isin)"
              /></a>
            </td>
            <!--            <td class="table__body align-right">-->
            <!--              <button-->
            <!--                @click="showModal(stockItem)"-->
            <!--                class="button table__button"-->
            <!--              >-->
            <!--                {{ $t("buy") }}-->
            <!--              </button>-->
            <!--            </td>-->
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SelectPrimary from "@/components/ui-kit/SelectPrimary";
import { HalfCircleSpinner } from "epic-spinners";
import { replaceCommas, formatMoney, income } from "@/helpers/money";

import ModalWrapper from "@/components/ui-kit/ModalWrapper";
import ModalContent from "@/components/stock/StockModalContent";

export default {
  components: {
    "fhs-select": SelectPrimary,
    spinner: HalfCircleSpinner,
    "modal-wrapper": ModalWrapper,
    "modal-content": ModalContent
  },
  data() {
    return {
      searchQuery: "",
      isStockModalVisible: false,
      stockForModal: {}
    };
  },
  computed: {
    ...mapGetters([
      "stockList",
      "securitiesTypes",
      "watchList",
      "isStockListLoading"
    ])
  },
  methods: {
    formatMoney,
    getIncome(amount, dealAmount) {
      return income(replaceCommas(amount), replaceCommas(dealAmount));
    },
    // Возвращаем класс для окраски блока в зависимости от дохода (красный - убыток, зеленый - доход)
    getIncomeColor(income) {
      if (Math.sign(income) === 1) {
        return "table__body_green";
      } else if (Math.sign(income) === -1) {
        return "table__body_red";
      }
    },
    onSecurityTypeSelect(securityType) {
      // Показываем лоадер
      this.$store.dispatch("clearStockList");
      // Изменяем значение выбранного типа бумаги
      this.$store.dispatch("changeSecurityType", securityType);
      // Загружаем новый список
      this.$store.dispatch("fetchStockList");
    },
    isSubscribed(securityTicker) {
      if (this.watchList === null) {
        return;
      }
      // Проходимся по всему WatchList'у, если данная бумага в нем есть, возвращаем true, иначе false
      for (let i = 0; i < this.watchList.length; i++) {
        if (this.watchList[i].instrument === securityTicker) {
          return "true";
        }
      }
      return "false";
    },
    handleFavoritesButtonClick(e) {
      let securityTicker = e.target.id;
      let isSubscribed = e.target.dataset.issubscribed;
      if (isSubscribed === "true") {
        this.$store.dispatch("unsubscribeToSecurity", securityTicker);
      } else if (isSubscribed === "false") {
        this.$store.dispatch("subscribeToSecurity", securityTicker);
      }
    },
    handleSearchSubmit() {
      // Если длина слов равен 3 и больше посылаем запрос
      if (this.searchQuery.length >= 3) {
        // Очищаем список инструментов, чтобы показался прелоадер
        this.$store.dispatch("clearStockList");
        // Загружаем список инструментов на основе строки поиска
        this.$store.dispatch("fetchStockList", this.searchQuery);
      }
    },
    showModal(stock) {
      this.stockForModal = stock;
      this.isStockModalVisible = true;
    },
    hideStockModal() {
      this.isStockModalVisible = false;
    }
  },
  mounted() {
    this.$store.dispatch("fetchWatchList");
    this.$store.dispatch("fetchStockList");
  }
};
</script>

<style scoped>
.body {
  padding: 35px 30px 0;
}

.body__controls {
  height: 39px;
  display: flex;
}

.controls__search {
  margin-left: 20px;
  height: 100%;
  padding: 0 12px;
  font-size: 15px;
  background-color: #ffffff;
  border: 1px solid #acb5c5;
  border-radius: 5px;
  outline: none;
}

.button {
  padding: 10px 20px;
  font-size: 15px;
  border: 1px solid #acb5c5;
  color: #222c44;
}

.button:hover {
  color: #ffffff;
  border: 1px solid #2e79ef;
}

.body__table-container {
  min-height: 40vh;
  position: relative;
}

.body__table-preloader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.table__button {
  border: 1px solid #2e79ef;
}

.table__subscription-button {
  cursor: pointer;
}
</style>
